//
// Product Type Tab switcher
//
export default class ProductTypeTabs {
  constructor() {

    // Check for product purchase element
    this.el = document.querySelector('.product-purchase');
    if (!this.el) return;

    // Product type tab content
    this.productTypeButtons = document.querySelectorAll('.js-product-purchase__type-button');
    this.productTypeTabs = document.querySelectorAll('.js-product-type__tab');

    this.init();
  }

  init() {
    this.addEventHandling();

    //
    // Switch active tab if query string is present
    //
    // Get query string parameter
    const urlParams = new URLSearchParams(window.location.search);
    const productTypeSectionParam = urlParams.get('section');

    if (productTypeSectionParam) {

      let activeProductTypeButton = document.querySelector(".js-product-purchase__type-button[data-product-type-target='" + productTypeSectionParam + "']");

      // Click active button
      if (activeProductTypeButton) {
        activeProductTypeButton.click();
      }

    }

  }

  /**
   * @public
   */
  showProductTypeTab(event) {
    event.preventDefault();

    // Get target tab class
    let currentProductTypeButton = event.currentTarget;
    let targetProductTypeTab = currentProductTypeButton.dataset.productTypeTarget;

    // Remove active class from all buttons
    this.productTypeButtons.forEach(productTypeButton => {
      productTypeButton.classList.remove('product-purchase__type-button--active');
    });
    // Add active class to current button
    currentProductTypeButton.classList.add('product-purchase__type-button--active');

    // Hide all tabs, show active
    this.productTypeTabs.forEach(productTypeTab => {

      productTypeTab.classList.remove('product-type__tab--active');

      // Get productTypeTab handle
      let currentProductTypeTabHandle = productTypeTab.dataset.productTypeTab;

      // If current product tab matches target button, then show
      if (currentProductTypeTabHandle === targetProductTypeTab) {
        productTypeTab.classList.add('product-type__tab--active');
      }
    });

  }

  addEventHandling() {
    this.productTypeButtons.forEach(productTypeTrigger => {
      productTypeTrigger.addEventListener('click', this.showProductTypeTab.bind(this));
    });

  }
}